import { render, staticRenderFns } from "./CommissionsModal.vue?vue&type=template&id=c36e2d24&scoped=true"
import script from "./CommissionsModal.vue?vue&type=script&lang=js"
export * from "./CommissionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36e2d24",
  null
  
)

export default component.exports